import GameConfig from "../core/data/GameConfig";
import GameScene from "../scenes/GameScene";
import { Component } from "./Component";
import { Player } from "./Player";
import { PlayerMovement } from "./PlayerMovement";

export class AirInput extends Component {
	scene: GameScene;
	obj: Player;
	pointerDown = false;
	inputObject: Phaser.GameObjects.Image;
	progress = 0;
	finalProgress: number;
	//trickMeter: TrickMeter;
	inputEnabled = true;
	performedTrick = false;
	correctTrick: boolean;
	noInput: boolean;
	pointerY: number;
	pointerX: number;
	distX: number;
	distY: number;
	//Original values
	readonly targetMin = 0.4; //0.7
	readonly targetMax = 0.5; //0.8
	readonly target2Min = 0.27; //0.57
	readonly target2Max = 0.63; //0.93
	cursors: Phaser.Types.Input.Keyboard.CursorKeys;

	constructor(player: Player, inputObj: Phaser.GameObjects.Image) {
		super(player);
		this.scene = player.scene;
		this.inputObject = inputObj;

		player.getComponent(PlayerMovement).events.once(PlayerMovement.ON_HIT_GROUND, this.onHitGround, this);

		// const meter = (this.trickMeter = new TrickMeter(this.scene, this.targetMin, this.targetMax, this.target2Min, this.target2Max));
		// this.scene.hudContainer.add(meter);
		// this.scene.alignIn.Center(meter, this.scene.viewport, 0, -200);

		inputObj.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		this.scene.input.on(Phaser.Input.Events.POINTER_MOVE, this.onPointerMove, this);
		this.scene.input.on(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
		this.cursors = this.scene.input.keyboard.createCursorKeys();
	}

	destroy(): void {
		this.inputObject.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onPointerDown, this);
		this.scene.input.off(Phaser.Input.Events.POINTER_UP, this.onPointerUp, this);
		//this.trickMeter.destroy();
	}

	keyPressed(event: string): void {
		if (event == "up") {
			if (!this.performedTrick) this.swipedUp();
		} else if (event == "left") {
			if (!this.performedTrick) this.swipedLeft();
		} else if (event == "right") {
			if (!this.performedTrick) this.swipedRight();
		}
		this.performedTrick = true;
		this.noInput = false;
	}

	onPointerDown(ptr: Phaser.Input.Pointer): void {
		if (this.inputEnabled) {
			this.pointerDown = true;
			this.pointerX = ptr.x;
			this.pointerY = ptr.y;
		}
	}
	onPointerMove(ptr: Phaser.Input.Pointer): void {
		if (this.pointerDown) {
			const distY = (this.distY = ptr.y - this.pointerY);
			const distX = (this.distX = ptr.x - this.pointerX);

			if (distX < -50) {
				this.pointerY = ptr.y;
				this.swipedLeft();
				this.performedTrick = true;
			} else if (distX > 50) {
				this.pointerY = ptr.y;
				this.swipedRight();
				this.performedTrick = true;
			}
			if (distY < -50) {
				this.pointerX = ptr.x;
				this.swipedUp();
				this.performedTrick = true;
			}
			if (this.distX > -50 && this.distX < 50 && this.distY > -50 && this.distY < 50) {
				this.noInput = true;
			} else this.noInput = false;
		}
	}

	swipedLeft(): void {
		if (this.performedTrick) return;
		if (this.obj.trickDirection == "left") this.correctTrick = true;
		else this.correctTrick = false;
		const trick = "trick_1";
		this.obj.animator.play(trick);
	}

	swipedUp(): void {
		if (this.performedTrick) return;
		if (this.obj.trickDirection == "up") this.correctTrick = true;
		else this.correctTrick = false;

		const trick = "trick_2";
		this.obj.animator.play(trick);
	}

	swipedRight(): void {
		if (this.performedTrick) return;
		if (this.obj.trickDirection == "right") this.correctTrick = true;
		else this.correctTrick = false;

		const trick = "trick_3";
		this.obj.animator.play(trick);
	}

	update(dt: number): void {
		if (!this.performedTrick) {
			if (this.cursors.up.isDown) this.keyPressed("up");
			if (this.cursors.left.isDown) this.keyPressed("left");
			else if (this.cursors.right.isDown) this.keyPressed("right");
		}
	}

	onPointerUp(ptr: Phaser.Input.Pointer): void {
		if (this.pointerDown) {
			this.pointerDown = false;
			this.inputEnabled = false;
		}
	}

	onHitGround(): void {
		let score = 0;
		this.obj.onRamp = false;
		this.obj.movement.enableLaneSwitch = true;
		if (!this.performedTrick) score = GameConfig.get("scoreNoInput");
		else if (this.performedTrick && this.correctTrick) score = GameConfig.get("scoreCorrect");
		else if (this.performedTrick && !this.correctTrick) score = GameConfig.get("scoreWrongDirection");
		this.performedTrick = false;
		this.correctTrick = false;

		if (score > 0) {
			this.obj.gainPoints(score, true);
		}

		if (this.performedTrick) {
			this.scene.soundManager.play("performTrickSFX");
			this.obj.playIdle();
		} else {
			this.obj.playIdleNext();
		}
		this.obj.playIdle();
	}
}
